class PublicationsPolling {
  constructor() {
    this.pollingInterval = null;
    this.pollingDuration = 1500000; // 25 minutos
    this.pollingFrequency = 5000; // 5 segundos
  }

  start() {
    const pollingCells = document.querySelectorAll('[data-publication-polling="true"]');

    if (pollingCells.length === 0) {
      return;
    }

    this.checkAllPollingCells();
    this.pollingInterval = setInterval(() => this.checkAllPollingCells(), this.pollingFrequency);
    setTimeout(() => this.stop(), this.pollingDuration);
  }

  stop() {
    if (!this.pollingInterval) {
      return;
    }

    clearInterval(this.pollingInterval);
    this.pollingInterval = null;
  }

  checkAllPollingCells() {
    const pollingCells = document.querySelectorAll('[data-publication-polling="true"]');

    if (pollingCells.length === 0) {
      this.stop();
      return;
    }

    pollingCells.forEach((cell) => {
      this.updateCell(cell);
    });
  }

  updateCell(cell) {
    const cellUrl = cell.dataset.publicationUrl;

    if (!cellUrl) {
      return;
    }

    fetch(cellUrl, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        return response.text();
      })
      .then((html) => {
        const currentCell = document.getElementById(cell.id);

        if (!currentCell) {
          return;
        }

        const container = document.createElement('div');
        container.innerHTML = html.trim();

        const newCell = container.firstElementChild;

        if (!newCell) {
          return;
        }

        currentCell.outerHTML = newCell.outerHTML;

        if (window.feather) {
          window.feather.replace();
        }
      })
      .catch((error) => {
        console.error('Erro ao atualizar publicação OLX:', error);
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const polling = new PublicationsPolling();
  polling.start();
});

export default PublicationsPolling;
